require('@babel/polyfill');
import 'bootstrap';

import './pwa.js';
import '../scss/app.scss';
//import './slick.min.js'
import './carousel.js'
import '../scss/slick/_slick.scss'
import '../scss/slick/_slick-theme.scss'
import './navigation.js'
import './lightbox.js'
import './email-an-expert.js'
import './email-sales.js'
import './job-listing-filter.js'
import './match-height.js'
import './framework.js'
import './investor.js'
import './parallax.min.js'
import './marketing.js'
// import './canvas-marquee.js'
//import './marquee.js'

var hamburger = document.querySelector(".hamburger");
// On click
hamburger.addEventListener("click", function () {
    // Toggle class "is-active"
    hamburger.classList.toggle("is-active");
    // Do something else, like open/close menu
});

var lastScrollTop=0; 

$(document).ready(function () {
	lastScrollTop=0; 
		window.addEventListener('scroll',function(){
		 //on every scroll this funtion will be called
			var navbar = document.getElementById('primaryNavbar'); // Get The NavBar

			var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			//This line will get the location on scroll

			if(scrollTop > lastScrollTop){ //if it will be greater than the previous
					if(scrollTop > 150){
				navbar.style.top='-150px';
					}
				//set the value to the negetive of height of navbar
			}

			else{
				navbar.style.top='0';
			}

			lastScrollTop = scrollTop; //New Position Stored
		});


    let click = 0
    $(document).click(function (event) {
        let $target = $(event.target);
        if ($target[0].id !== 'search-button') {
            click = 0
            $('.search-button').removeClass('bg-deep-blue-9').addClass('bg-white')
        } else {
            if (click === 1) {
                $("#search-form").submit()
            } else {
                click = 1
                $('.search-bar').focus();
                $('.search-button').removeClass('bg-white').addClass('bg-deep-blue-9')
            }
        }
    });

	$(window).scroll(function() {
		if ($(this).scrollTop() > 40){
			$('.nav-wrap').addClass("bottomBorderShadow");
		}
		else{
			$('.nav-wrap').removeClass("bottomBorderShadow");
		}
	});


    jQuery('img.svg').each(function () {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
    $(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    $(document).on('click', '[data-toggle="lightbox-svg"]', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox();

    });

    $('#searchbutton').bind('click', function () {
        $('.ac-gn-curtain').fadeToggle();
        $('#searchbox').slideToggle();
    });

    $('.ac-gn-curtain').bind('click', function () {

        $('.ac-gn-curtain').fadeOut();
        $('#searchbox').slideUp();
    });

    const domains = ['qq.com', '10minutemail.com', '2prong.com', '4warding.com', '6url.com', 'afrobacon.com', 'bugmenot.com', 'bumpymail.com', 'centermail.com', 'centermail.net', 'choicemail1.com', 'deadspam.com', 'despam.it', 'despammed.com', 'discardm ail.com', 'discardmail.de', 'disposeamail.com', 'dodgeit.com', 'dontreg.com', 'dontsendmespam.de', 'dumpandjunk.com', 'dumpmail.de', 'e4ward.com', 'emaildienst.de', 'emailias.com', 'emailto.de', 'emailxfer.com', 'emz.net', 'enterto.com', 'front14.org', 'getonemail.com', 'ghosttexter.de', 'gishpuppy.com', 'greensloth.com', 'guerrillamail.com', 'guerrillamail.net', 'h8s.org', 'haltospam.com', 'hatespam.org', 'hidemail.de', 'iheartspam.org', 'ipoo.org', 'jetable.com', 'jetable.net', 'jetable.org', 'kasmail.com', 'killmail.com', 'killmail.net', 'klassmaster.net', 'link2mail.net', 'lortemail.dk', 'mail2rss.org', 'mail333.com', 'mailblocks.com', 'maileater.com', 'mailexpire.com', 'mailfreeonline.com', 'mailmoat.com', 'mailnull.com', 'mailshell.com', 'mailsiphon.com', 'mailzilla.com', 'meinspamschutz.de', 'messagebeamer.de', 'mintemail.com', 'myspamless.com', 'mytrashmail.com', 'neomailbox.com', 'nervmich.net', 'nervtmich.net', 'netmails.com', 'netmails.net', 'netzidiot.de', 'nobulk.com', 'noclickemail.com', 'nospamfor.us', 'nurfuerspam.de', 'oneoffemail.com', 'oopi.org', 'outlawspam.com', 'pancakemail.com', 'poofy.org', 'pookmail.com', 'privacy.net', 'punkass.com', 'rejectmail.com', 'safersignup.de', 'shortmail.net', 'sibmail.com', 'slaskpost.se', 'sneakemail.com', 'sofort-mail.de', 'spam.la', 'spamavert.com', 'spambob.com', 'spambob.net', 'spambob.org', 'spambox.us', 'spamcon.org', 'spamday.com', 'spamex.com', 'spamfree24.com', 'spamfree24.net', 'spamfree24.org', 'spamgourmet.com', 'spamhole.com', 'spamify.com', 'spaminator.de', 'spamslicer.com', 'spaml.com', 'spammotel.com', 'spamoff.de', 'spamtrail.com', 'tempemail.net', 'tempinbox.com', 'temporarily.de', 'temporaryforwarding.com', 'temporaryinbox.com', 'trashmail.com', 'trashmail.net', 'trashmail.org', 'trashmail.de', 'trash-mail.de', 'twinmail.de', 'venompen.com', 'wegwerfadresse.de', 'wh4f.org', 'willselfdestruct.com', 'wuzup.net', 'wwwnew.eu', 'xemaps.com', 'xents.com', 'xmaily.com', 'yep.it', 'yopmail.com', 'zoemail.org', 'fakeinformation.com', 'fastacura.com', 'fastchevy.com', 'fastchrysler.com', 'fastkawasaki.com', 'fastmazda.com', 'fastmitsubishi.com', 'fastnissan.com', 'fastsubaru.com', 'fastsuzuki.com', 'fasttoyota.com', 'fastyamaha.com', 'fux0ringduh.com', 'klassmaster.com', 'mailin8r.com', 'mailinator.com', 'mailinater.com', 'mailinator2.com', 'sogetthis.com', '675hosting.com', '675hosting.net', '675hosting.org', '75hosting.com', '75hosting.net', '75hosting.org', 'ajaxapp.net', 'amiri.net', 'amiriindustries.com', 'emailmiser.com', 'etranquil.com', 'etranquil.net', 'etranquil.org', 'gowikibooks.com', 'gowikicampus.com', 'gowikicars.com', 'gowikifilms.com', 'gowikigames.com', 'gowikimusic.com', 'gowikinetwork.com', 'gowikitravel.com', 'gowikitv.com', 'iwi.net', 'myspaceinc.com', 'myspaceinc.net', 'myspaceinc.org', 'myspacepimpedup.com', 'ourklips.com', 'pimpedupmyspace.com', 'rklips.com', 'turual.com', 'upliftnow.com', 'uplipht.com', 'viditag.com', 'viewcastmedia.com', 'viewcastmedia.net', 'viewcastmedia.org', 'wetrainbayarea.com', 'wetrainbayarea.org', 'xagloo.com', 'anonymail.dk', 'blogmyway.org', 'buyusedlibrarybooks.org', 'dotmsg.com', 'fakemailz.com', 'footard.com', 'forgetmail.com', 'lovemeleaveme.com', 'mailquack.com', 'mailslapping.com', 'oneoffmail.com', 'recyclemail.dk', 'shiftmail.com', 'spambog.com', 'spambog.de', 'spammotel.com', 'trashdevil.com', 'trashdevil.de', 'whopy.com', 'wilemail.com', '1chuan.com', '1zhuan.com', '4warding.com', '4warding.net', '4warding.org', 'imstations.com', 'walala.org', 'gorillaswithdirtyarmpits.com', 'bugmenot.com', 'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.co.uk', 'live.com', 'yahoo.in', 'hotmail.com', 'hotmail.co.uk', 'rocketmail.com', 'ymail.com', 'ymail.co.uk', 'aol.com']

    $('.__downloadGitBin').click(function () {
        const id = $(this).data('bid')
        const title = $(this).data('title')
        $('#binary-download-modal-label').text(title)
        $('#binary-download-modal-label-2').text(title)
        $('#binary-download_git_form__binary-id').val(id)

    })

    $('.__downloadSvnBin').click(function () {
        const id = $(this).data('bid')
        const title = $(this).data('title')
        $('#binary-download-modal-label').text(title)
        $('#binary-download-modal-label-2').text(title)
        $('#binary-download_Subversion_form__binary-id').val(id)
    })

    //
    // function downloadSubDialog(id, title) {
    //     $('#binary-download-modal-label').text(title)
    //     $('#binary-download-modal-label-2').text(title)
    //     $('#binary-download_Subversion_form__binary-id').val(id)
    // }
    // function downloadDialog(id, title) {
    //     $('#binary-download-modal-label').text(title)
    //     $('#binary-download-modal-label-2').text(title)
    //     $('#binary-download_git_form__binary-id').val(id)
    // }

    $('#binary-download_git_form input').on('change', function () {
        if (isValidForm()) {
            $('#binary-download_git_form__form_submit').prop('disabled', false)
        } else {
            $('#binary-download_git_form__form_submit').prop('disabled', true)
        }
    })

    $('#binary-download_git_form__form').submit(function (event) {
        event.preventDefault();
        if (isValidForm()) {
            this.submit()
        }
    })

    $('#binary-download_git_form__email').on('change', function () {
        $('#binary-download_git_form__email_error').css('display', 'none')
        if (!isNonFreeEmail()) {
            $('#binary-download_git_form__email_error').css('display', 'block').text('Free email accounts are not valid.')
        }
        if (!isValidEmail()) {
            $('#binary-download_git_form__email_error').css('display', 'block').text('Please enter a valid email address.')
        }
    })
    $('#binary-download_git_form__first-name').on('change', function () {
        $('#binary-download_git_form__first-name_error').hide()
        if (!isValidFirstName()) {
            $('#binary-download_git_form__first-name_error').css('display', 'block').text('Please enter your first name.')
        }
    })
    $('#binary-download_git_form__last-name').on('change', function () {
        $('#binary-download_git_form__last-name_error').hide()
        if (!isValidLastName()) {
            $('#binary-download_git_form__last-name_error').css('display', 'block').text('Please enter your last name.')
        }
    })
    $('#binary-download_git_form__company-name').on('change', function () {
        $('#binary-download_git_form__company-name_error').hide()
        if (!isValidCompanyName()) {
            $('#binary-download_git_form__company-name_error').css('display', 'block').text('Please enter your company name.')
        }
    })
    $('#binary-download_git_form__phone').on('change', function () {
        $('#binary-download_git_form__phone_error').hide()
        if (!isValidPhone()) {
            $('#binary-download_git_form__phone_error').css('display', 'block').text('Please enter a contact number.')
        }
    })


    function isValidFirstName() {
        return $('#binary-download_git_form__first-name').val().length >= 2
    }

    function isValidLastName() {
        return $('#binary-download_git_form__last-name').val().length >= 2
    }

    function isValidCompanyName() {
        return $('#binary-download_git_form__company-name').val().length >= 2
    }

    function isValidPhone() {
        return $('#binary-download_git_form__phone').val().length > 7
    }

    function isNonFreeEmail() {
        return !domains.some((dom) => {
            return $('#binary-download_git_form__email').val().includes(dom)
        })
    }

    function isValidEmail() {
        return /\S+@\S+\.\S+/.test($('#binary-download_git_form__email').val())
    }

    function isTermsAgreed() {
        return $('#binary-download_git_form__agree').prop('checked')
    }

    function isValidForm() {
        if (
            isValidFirstName() &&
            isValidLastName() &&
            isValidCompanyName() &&
            isValidEmail() &&
            isNonFreeEmail() &&
            isValidPhone() &&
            isTermsAgreed()
        ) {
            return true
        }
        return false
    }

    $('#binary-download_Subversion_form input').on('change', function () {
        if (isValidSubForm()) {
            $('#binary-download_Subversion_form__form_submit').prop('disabled', false)
        } else {
            $('#binary-download_Subversion_form__form_submit').prop('disabled', true)
        }
    })

    $('#binary-download_Subversion_form__form').submit(function (event) {
        event.preventDefault();
        if (isValidSubForm()) {
            this.submit()
        }
    })

    $('#binary-download_Subversion_form__email').on('change', function () {
        $('#binary-download_Subversion_form__email_error').hide()
        if (!isNonFreeSubEmail()) {
            $('#binary-download_Subversion_form__email_error').css('display', 'block').text('Free email accounts are not valid.')
        }
        if (!isValidSubEmail()) {
            $('#binary-download_Subversion_form__email_error').css('display', 'block').text('Please enter a valid email address.')
        }
    })
    $('#binary-download_Subversion_form__first-name').on('change', function () {
        $('#binary-download_Subversion_form__first-name_error').hide()
        if (!isValidSubFirstName()) {
            $('#binary-download_Subversion_form__first-name_error').css('display', 'block').text('Please enter your first name.')
        }
    })
    $('#binary-download_Subversion_form__last-name').on('change', function () {
        $('#binary-download_Subversion_form__last-name_error').hide()
        if (!isValidSubLastName()) {
            $('#binary-download_Subversion_form__last-name_error').css('display', 'block').text('Please enter your last name.')
        }
    })
    $('#binary-download_Subversion_form__company-name').on('change', function () {
        $('#binary-download_Subversion_form__company-name_error').hide()
        if (!isValidSubCompanyName()) {
            $('#binary-download_Subversion_form__company-name_error').css('display', 'block').text('Please enter your company name.')
        }
    })
    $('#binary-download_Subversion_form__phone').on('change', function () {
        $('#binary-download_Subversion_form__phone_error').hide()
        if (!isValidSubPhone()) {
            $('#binary-download_Subversion_form__phone_error').css('display', 'block').text('Please enter a contact number.')
        }
    })


    function isValidSubFirstName() {
        return $('#binary-download_Subversion_form__first-name').val().length >= 2
    }

    function isValidSubLastName() {
        return $('#binary-download_Subversion_form__last-name').val().length >= 2
    }

    function isValidSubCompanyName() {
        return $('#binary-download_Subversion_form__company-name').val().length >= 2
    }

    function isValidSubPhone() {
        return $('#binary-download_Subversion_form__phone').val().length > 7
    }

    function isNonFreeSubEmail() {
        return !domains.some((dom) => {
            return $('#binary-download_Subversion_form__email').val().includes(dom)
        })
    }

    function isValidSubEmail() {
        return /\S+@\S+\.\S+/.test($('#binary-download_Subversion_form__email').val())
    }

    function isSubTermsAgreed() {
        return $('#binary-download_Subversion_form__agree').prop('checked')
    }

    function isValidSubForm() {
        if (
            isValidSubFirstName() &&
            isValidSubLastName() &&
            isValidSubCompanyName() &&
            isValidSubEmail() &&
            isNonFreeSubEmail() &&
            isValidSubPhone() &&
            isSubTermsAgreed()
        ) {
            return true
        }
        return false
    }

    


});
var elm=document.getElementById('gdprBannerOptInBtn'); 
if(elm){ 
		elm.addEventListener("click", function(){ 
				var elm=document.getElementById('gdprBanner1'); 
				elm.parentNode.removeChild(elm);
		});


}
